export default __webpack_public_path__ + "static/media/splashscreen_mainImg.208c9fa5.jpg";